import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1d132d1c&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=1d132d1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports